import config from './config.json';
import http from './httpService';


export const getTexture = (params) => {
    if (params.query_string_procode && params.query_string_group) {
        return http.get(`${config.ariisapi}/object/objfac/`,{
            params:{
                procode:params.query_string_procode,
                group:params.query_string_group
            }
        });
    }else{
        return http.get(`${config.ariisapi}/object/objfac/`)
    }
};

export const uploadImage = (data) => {
    return http.post(`${config.ariisapi}/log/upload/`,data);
};

export const changeTexture = (data) => {
    // Modify the data structure
    const modifiedData = {
        point: { points: [0], object_id: data.object_id },
        procode: data.procode,
        featur_value: data.featur_value,
        token: data.token
    };

    // Send HTTP POST request with modified data
    return http.post(`${config.ariisapi}/log/newdistinction/`, modifiedData);
}

export const sendLocation = (data) => {
    return http.post(`${config.ariisapi}/log/upload/`,data);
}

//ip-check
export const ipCheckApi = () => {
    return http.get(`${config.ariisapi}/log/ip-check/`);
}
